<template>
  <div>
    <div class="flex justify-between text-sm text-grey mt-2">
      <span class="hover:cursor-pointer" @click="toggle">
        <i
          class="mx-2 fa"
          :class="[expanded ? 'fa-chevron-down' : 'fa-chevron-right']"
        ></i>
        {{ histories.length - 1 }} more updates
      </span>
    </div>
    <div v-if="expanded" class="ml-2 my-2 text-grey-darker text-sm">
      <div v-for="(history, index) in histories" :key="history.id">
        <div
          class="flex justify-between mb-2 text-xs border-l-2 border-brand pl-2"
          v-if="index > 0"
        >
          <span v-html="constructMessage(history)" class="mr-4"></span>
          <span>{{ formatCalendar(history.updated_at) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "TaskHistoryItem",
  props: ["histories"],
  data() {
    return {
      expanded: false,
    };
  },
  methods: {
    constructMessage(history) {
      let message = "";

      for (const property in history.old_values) {
        if (property != "done_at") {
          message += `<p class="mb-1">Updated ${this.substituteKey(
            property
          )} from <span class="font-semibold">${
            property == "due_at"
              ? this.formatDate(history.old_values[property])
              : this.substituteChange(history.old_values[property])
          }</span> to <span class="font-semibold">${
            property == "due_at" || property == "done_at"
              ? this.formatDate(history.new_values[property])
              : this.substituteChange(history.new_values[property])
          }</span> </p>`;
        }
      }

      return message;
    },
    substituteKey(key) {
      if (key == "due_at") return "due date";
      if (key == "is_done") return "status";
      if (key == "done_at") return "done at";

      return key;
    },
    substituteChange(change) {
      if (change == 0) return "pending";
      if (change == true) return "completed";
      if (change == null) return "-";

      return change;
    },
    formatDate(date, format = "lll") {
      return moment(date).format(format);
    },
    formatCalendar(date) {
      return moment(date).calendar();
    },
    toggle() {
      this.expanded = !this.expanded;
    },
  },
};
</script>